import { useCallback } from 'react';
import { useUpdatePurchaseOrderBundleState } from '../api/hooks/bundles';
import { PoStatus } from './usePurchaseOrderService';
import { usePurchaseOrder } from './usePurchaseOrders';

export const useUpdatePurchaseOrderState = (partnerId: string, companyId: string, orderId: string) => {
  const updatePurchaseOrder = useUpdatePurchaseOrderBundleState();
  const storedOrder = usePurchaseOrder(orderId);

  if (!storedOrder) {
    throw Error('Could not find Purchase Order');
  }

  return useCallback(
    async (newStatus: PoStatus) => {
      const payload = {
        customerId: companyId,
        mspId: partnerId,
        id: orderId!,
        state: newStatus
      };

      return await updatePurchaseOrder.mutateAsync(payload);
    },
    [storedOrder, updatePurchaseOrder, companyId, partnerId]
  );
};
